import { SuggestionFormModal } from '@pages/DocumentPage/DocumentDetails/AccountingSuggestions/SuggestionFormModal'
import AccountingRuleFormModal from '@root/pages/SettingsPage/sections/AutomationSettings/AccountingRule/Form/AccountingRuleFormModal'
import { IAccountingRule } from '@root/query/accountingRules'
import { IAccountingSuggestion, IAccountingSuggestionAcceptPayload } from '@root/query/suggestions'
import React from 'react'

interface SuggestionCardModalsProps {
  suggestionForEdit: IAccountingSuggestion
  attachmentExempt: boolean
  showEdit: boolean
  showAccountingRuleForm: boolean
  defaultRule: Partial<IAccountingRule> | null
  onCloseEdit: () => void
  onEditFormValuesChange?: (values: Partial<IAccountingSuggestionAcceptPayload>) => void
  onCreateSuggestion: (data: Partial<IAccountingSuggestionAcceptPayload>) => Promise<any>
  onCloseRuleForm: () => void
  onRuleCreated: () => void
}

export const SuggestionCardModals: React.FC<SuggestionCardModalsProps> = ({
  suggestionForEdit,
  attachmentExempt,
  showEdit,
  showAccountingRuleForm,
  defaultRule,
  onCloseEdit,
  onEditFormValuesChange,
  onCreateSuggestion,
  onCloseRuleForm,
  onRuleCreated
}) => {
  return (
    <>
      <SuggestionFormModal
        isVisible={showEdit}
        onClose={onCloseEdit}
        suggestion={suggestionForEdit}
        attachmentExempt={attachmentExempt}
        onCreate={onCreateSuggestion}
        onFormValuesChange={onEditFormValuesChange}
      />

      {showAccountingRuleForm && defaultRule && (
        <AccountingRuleFormModal
          isVisible={showAccountingRuleForm}
          handleOnClose={onCloseRuleForm}
          handleOnSuccess={onRuleCreated}
          rule={defaultRule}
        />
      )}
    </>
  )
}
